import type {
  BoxFragment,
  ImageBlockFragment,
  ImageBlockGroupFragment,
} from '@seek/cmsu-cms-connect';
import { Box } from 'braid-design-system';
import React from 'react';

import { InlineImageBlock } from './InlineImageBlock';
import { RegularImageBlock } from './RegularImageBlock';

type Props = Pick<
  ImageBlockFragment,
  | 'heading'
  | 'image'
  | 'paragraph'
  | 'cButtonLink'
  | 'cTextLink'
  | 'dialogButton'
  | 'reverseContent'
  | 'accentBar'
> &
  Pick<
    ImageBlockGroupFragment,
    | 'inlineBlockItem'
    | 'blockBackground'
    | 'blockBorder'
    | 'imageAlignment'
    | 'stackBelow'
  > & {
    inlineTextJustify?: BoxFragment['justifyContent'];
    textAlign?: BoxFragment['textAlign'];
  };

const ImageBlock = ({
  image,
  heading,
  paragraph,
  inlineBlockItem,
  blockBackground,
  blockBorder,
  imageAlignment,
  cButtonLink,
  cTextLink,
  dialogButton,
  stackBelow,
  inlineTextJustify,
  textAlign,
  reverseContent,
  accentBar,
}: Props) => (
  <Box data={{ testid: 'ImageBlockTestId' }} height="full">
    {inlineBlockItem ? (
      <InlineImageBlock
        imageAlignment={imageAlignment}
        heading={heading}
        image={image}
        paragraph={paragraph}
        blockBackground={blockBackground}
        blockBorder={blockBorder}
        cButtonLink={cButtonLink}
        cTextLink={cTextLink}
        dialogButton={dialogButton}
        inlineTextJustify={inlineTextJustify}
        stackBelow={stackBelow}
        reverseContent={reverseContent}
        accentBar={accentBar}
      />
    ) : (
      <RegularImageBlock
        heading={heading}
        image={image}
        imageAlignment={imageAlignment}
        textAlign={textAlign}
        paragraph={paragraph}
        blockBackground={blockBackground}
        blockBorder={blockBorder}
        cButtonLink={cButtonLink}
        cTextLink={cTextLink}
        dialogButton={dialogButton}
        reverseContent={reverseContent}
      />
    )}
  </Box>
);
export { ImageBlock };
